// Services
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
export class ComplianceReportService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    getComplianceReports(params) {
        const url = this.urlsService.COMPLIANCE.COLLECTION;
        return this.ajaxService.getDataObserveBody(url, params);
    }
}
ComplianceReportService.ɵfac = function ComplianceReportService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ComplianceReportService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
ComplianceReportService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ComplianceReportService, factory: ComplianceReportService.ɵfac, providedIn: 'root' });
